<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<div [class.slds-has-error]="isError"
     class="slds-form-element fk-list">
  <label *ngIf="ff"
         [for]="theId + '_fkar'"
         class="slds-form-element__label">
    <abbr *ngIf="isUiRequired" class="slds-required" title="required">* </abbr>
    {{ label }}
    <small>{{ ff.description }}</small>
  </label>

  <div class="slds-form-element__control">
    <div class="slds-combobox_container">
      <div [attr.aria-expanded]="showAutoReduction"
           [class.slds-dropdown-trigger_click]="!useHover"
           [class.slds-dropdown-trigger_hover]="useHover"
           [class.slds-is-open]="showAutoReduction"
           aria-haspopup="listbox"
           class="slds-combobox slds-dropdown-trigger"
           role="combobox">
        <div class="slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right" role="none">
          <input #fkar
                 (click)="onAutoReductionClick($event)"
                 (focus)="onFocus()"
                 (keydown)="onAutoReductionKeyDown($event)"
                 (keyup)="onAutoReductionKeyUp($event)"
                 [attr.aria-activedescendant]="theId + '_op_' + fkInfo.fkId"
                 [attr.aria-controls]="theId + '_fkar-list'"
                 [class.ng-dirty]="control?.dirty"
                 [disabled]="isDisabled || isReadOnly"
                 [id]="theId + '_fkar'"
                 [readOnly]="isReadOnly"
                 aria-autocomplete="list"
                 autoComplete="off"
                 class="slds-input slds-combobox__input slds-combobox__input-value"
                 role="textbox"
                 style="min-width: 12rem"
                 title="enter search term - ESC clears - UP/DOWN changes - TAB/ENTER picks"
                 type="text"/>
          <button (click)="onAutoReductionClear($event)"
                  class="slds-button slds-button_icon slds-input__icon slds-input__icon_right"
                  tabindex="-1"
                  title="Clear Selection"
                  type="button">
            <svg aria-hidden="true" class="slds-button__icon slds-button__icon_hint">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#picklist_choice"></use>
            </svg>
            <span class="slds-assistive-text">Clear Selection</span>
          </button>
        </div>

        <div [id]="theId + '_fkar-list'"
             class="slds-dropdown slds-dropdown_length-10 slds-dropdown_fluid"
             role="listbox">
          <ul class="slds-listbox slds-listbox_vertical" role="presentation">

            <li #fkarli
                *ngFor="let op of options"
                [class.slds-hide]="!op.isMatched"
                class="slds-listbox__item"
                role="presentation">
              <div (click)="onAutoReductionSelect(op)"
                   [attr.aria-selected]="op.isSelected"
                   [class.slds-has-focus]="op.isSelected"
                   [id]="theId + '_op_' + op.fkId"
                   class="slds-media slds-listbox__option slds-listbox__option_plain slds-media_small"
                   role="option">
                <span class="slds-media__body">
                  <span [innerHTML]="op.display"
                        [title]="op.label"
                        class="slds-listbox__option-text slds-listbox__option-text_entity slds-truncate"></span>
                </span>
              </div>
            </li>

          </ul>
        </div><!-- list -->

      </div>
    </div>
  </div><!--slds-form-element__control-->

  <div class="slds-form-element__help">{{errorMessage}}</div>
</div>
